import { hPost } from '@mcfe/tools';

/**
 * 获取固定属性、扩展属性的推荐值
 */
// eslint-disable-next-line import/prefer-default-export
export async function recommendMcAttrByAIAndData(skuName, bgCategoryId) {
    let res = {};
    try {
        res = await hPost(
            '/api/vss/shepherd/selection/ClueSkuQueryTService/recommendMcAttrByAIAndData',
            { skuName, bgCategoryId },
        );
    } catch (e) {
        console.error('请求接口 recommendMcAttrByAIAndData 失败:', e?.message, e);
    }
    return res;
}
